export default "__VITE_ASSET__BUpa_QMT__"